import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE, ANNOTATION_LOCATION} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';

export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/jesus-colleage%2Fjhaf-2021%2F";


export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
// export const GALLERY_LINK_LABEL = "WORKS";
export const GALLERY_LINK_LABEL = `<img src='/assets/languages/iconfinder_uk.png'>`;



const AnnotationsDB = [


    /* Room 1 */

    {
        paintingId: 'R1E02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R1E01C', 'R1E02C', 'R1E03C', 'R1E04C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'R1E02C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1E02.jpg/info.json`,
        headerText: '<h5>Summer</h5>',
        bodyText: `<b>Abby Wheeler</b><br>Pencil and watercolour pencil on paper<br><br>Like a lot of people, I started going back to old hobbies over the last year, since I suddenly had the time and necessity for a creative output. For these pieces, specifically, I wanted to capture the feeling of being inside in a grey, desaturated world while the colourful seasons passed - so fast it felt like just one day. I think it's a feeling that has become all too familiar to a lot of us. My style (the product of a fear of painting people and an inability to sketch landscapes) happened to fit this fairly well, and so this project was born.`,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R1E01C', 'R1E03C', 'R1E04C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },

    {
        paintingId: 'R1E01C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1E01.jpg/info.json`,
        headerText: '<h5>Spring</h5>',
        bodyText: `<b>Abby Wheeler</b><br>Pencil and watercolour pencil on paper<br><br>The main constellation in this piece is the constellation Hercules, the strongman. Hercules was an illegitimate child of Zeus, the King of Gods, and the human Alcmene. His conception was born of deceit and without consent (CN for r*pe if you decide to look into this further).<br>Also included is the constellation of Pisces.<br>This piece was developed through thoughts of bodies, gendered spaces, free will, and violence.<br><br>£150 (profits donated)`,
    },
    {
        paintingId: 'R1E03C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1E03.jpg/info.json`,
        headerText: '<h5>Autumn</h5>',
        bodyText: `<b>Abby Wheeler</b><br>Pencil and watercolour pencil on paper<br><br>Like a lot of people, I started going back to old hobbies over the last year, since I suddenly had the time and necessity for a creative output. For these pieces, specifically, I wanted to capture the feeling of being inside in a grey, desaturated world while the colourful seasons passed - so fast it felt like just one day. I think it's a feeling that has become all too familiar to a lot of us. My style (the product of a fear of painting people and an inability to sketch landscapes) happened to fit this fairly well, and so this project was born.`,
    },
    {
        paintingId: 'R1E04C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1E04.jpg/info.json`,
        headerText: '<h5>Winter</h5>',
        bodyText: `<b>Abby Wheeler</b><br>Pencil and watercolour pencil on paper<br><br>Like a lot of people, I started going back to old hobbies over the last year, since I suddenly had the time and necessity for a creative output. For these pieces, specifically, I wanted to capture the feeling of being inside in a grey, desaturated world while the colourful seasons passed - so fast it felt like just one day. I think it's a feeling that has become all too familiar to a lot of us. My style (the product of a fear of painting people and an inability to sketch landscapes) happened to fit this fairly well, and so this project was born.`,
        instagramUrl: 'instagram.com/apparently.abby',
    },
    {
        paintingId: 'R1E05',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1E05.jpg/info.json`,
        headerText: '<h5>they/them</h5>',
        bodyText: `<b>Amy Bottomley</b><br>Acrylic on canvas, with metallic embroidery thread<br><br>The main constellation in this piece is the constellation Hercules, the strongman. Hercules was an illegitimate child of Zeus, the King of Gods, and the human Alcmene. His conception was born of deceit and without consent (CN for r*pe if you decide to look into this further).<br>Also included is the constellation of Pisces.<br>This piece was developed through thoughts of bodies, gendered spaces, free will, and violence.<br><br>£150 (profits donated)`,
        instagramUrl: 'http://instagram.com/myintermission',
    },
    {
        paintingId: 'R1N01',
        videoId: 'R1N01',
        standaloneVideoElementId: 'R1N01',
        videoURL: 'R1N01.mp4',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1N01.jpg/info.json`,
        headerText: '<h5>Dominant Motion</h5>',
        bodyText: `<b>Toby Ashworth</b><br>Digital video<br><br>The bewildering movement of light in this image is actually the product of a camera unable to focus on the reflections of sunlight playing on the surface of a river. With the colour removed, the image and its source are deterritorialised. I like to think of it as a visualisation of thought processes (overthinking?) or perhaps networks of people, things, or ideas.`,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        displayMesh: 'N',
        // displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
        useVideoMeshButton: 'Y',


    },
    {
        paintingId: 'R1N04',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R1N02C', 'R1N03C', 'R1N04C', 'R1N05C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'R1N02C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1N02.jpg/info.json`,
        headerText: '<h5>Night sky from isolation</h5>',
        bodyText: `<b>Sophie Beckingham</b><br>Oil on paper<br><br>Many of my works this year have been of the various views I can see from quarantine. Spending 7/8 weeks of term in Michaelmas isolating was a hard, strange experience - seeing the same view every day forced me to see the differences in light, changes in seasons, evolution of the landscape I could see from me window in order to keep being excited by the same view. This piece is a part of a series of skies painted during these weeks of isolation.`,
        instagramUrl: 'http://instagram.com/sophiebeckingham.art',
    },
    {
        paintingId: 'R1N03C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1N03.jpg/info.json`,
        headerText: '<h5>Isolation window</h5>',
        bodyText: `<b>Sophie Beckingham</b><br>Oil on paper<br><br>Many of my works this year have been of the various views I can see from quarantine. Spending 7/8 weeks of term in Michaelmas isolating was a hard, strange experience - seeing the same view every day forced me to see the differences in light, changes in seasons, evolution of the landscape I could see from me window in order to keep being excited by the same view. This piece is a part of a series of skies painted during these weeks of isolation.`,
        instagramUrl: 'https://www.instagram.com/sophiebeckingham.art',
    },
    {
        paintingId: 'R1N04C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1N04.jpg/info.json`,
        headerText: '<h5>Sunset over the Cam</h5>',
        bodyText: `<b>Sophie Beckingham</b><br>Oil on paper<br><br>Many of my works this year have been of the various views I can see from quarantine. Spending 7/8 weeks of term in Michaelmas isolating was a hard, strange experience - seeing the same view every day forced me to see the differences in light, changes in seasons, evolution of the landscape I could see from me window in order to keep being excited by the same view. This piece is a part of a series of skies painted during these weeks of isolation.`,
        instagramUrl: 'https://www.instagram.com/sophiebeckingham.art',
    },
    {
        paintingId: 'R1N05C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1N05.jpg/info.json`,
        headerText: '<h5>Sunset from quarantine</h5>',
        bodyText: `<b>Sophie Beckingham</b><br>Oil on paper<br><br>Many of my works this year have been of the various views I can see from quarantine. Spending 7/8 weeks of term in Michaelmas isolating was a hard, strange experience - seeing the same view every day forced me to see the differences in light, changes in seasons, evolution of the landscape I could see from me window in order to keep being excited by the same view. This piece is a part of a series of skies painted during these weeks of isolation.`,
        instagramUrl: 'https://www.instagram.com/sophiebeckingham.art',
    },
    {
        paintingId: 'R1W01',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1W01.jpg/info.json`,
        headerText: '<h5>Self Portrait II</h5>',
        bodyText: `<b>Ella Curry</b><br>Lino print on recycled paper<br><br>This is a highly stylised lino print self-portrait that I created over lockdown. I designed it around astronomical and astrological themes, incorporating stars, the moon, the tides, and the sun. It was a really interesting challenge to communicate such bright, colourful objects in a black-and-white print, and to depict such huge objects on such a small scale.`,
        instagramUrl: 'https://www.instagram.com/ellamemtarycrafts',
    },
    {
        paintingId: 'R1W02',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1W02.jpg/info.json`,
        headerText: '<h5>Untitled 1</h5>',
        bodyText: `<b>Nik Yazikov</b><br>Medium format film, silver gelatin print<br><br>£20`,
        instagramUrl: 'https://www.instagram.com/yazikovnik',
        ContactURL: 'https://yazikovnik.com/',
    },
    {
        paintingId: 'R1W03',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1W03.jpg/info.json`,
        headerText: '<h5>people-watching</h5>',
        bodyText: `<b>Sieve Bonaiuti</b><br>Pencil and watercolours on paper<br><br>In the far away times when we were still able to go outside and sit in cafés or cinemas or other public places, we were surrounded by other people living their own lives, while we were living ours, all very different and yet all sharing the same place. I like the idea that all together we were creating a formation, a scene, in specific places which would have been different depending on the people accidentally coming together for those moments. Just like individually we were leading our different lives, in those moments we were creating a different scene, painting or constellation, together. In the drawing, a person notices it happening, while unknowingly being part of it themself.<br><br>£15`,
    },
    {
        paintingId: 'R1S01',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1S01.jpg/info.json`,
        headerText: '<h5>The Glastonbury folk singer</h5>',
        bodyText: `<b>Issie Weir</b><br>oil on canvas`,
    },
    {
        paintingId: 'R1S02',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1S02.jpg/info.json`,
        headerText: '<h5>Canal & sisters under winter sun (Moving to London series)</h5>',
        bodyText: `<b>Juliette Odolant</b><br>Acrylic on canvas<br><br>Moving from Paris to London during a global pandemic has been a strange experience, to say the least. But some things have made it better, worthwhile - family, though in doses, sunshine, though rare, short neighbourhood walks, though disorientating...<br><br>London streets, prim and white like rows of straight teeth, enamel a little blinding when the sun does come out. The winding canal when the light bounces off it, gurgling and warm. The cheerful brisk winter breeze, pinkening noses and sharpening breaths, it murmurs: yes, we’re all going through it together; but at least we’re out and there’s coffee in a cup and it is warming my hand and today you can beam up at the sun like a sunflower. In this painting, I tried to capture a little bit of that feeling - of hope, and of a thrill for the future, small but present, pulsing.`,
        instagramUrl: 'https://www.instagram.com/julietteodolant',
    },
    {
        paintingId: 'R1S03',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1S03.jpg/info.json`,
        headerText: '<h5>The washing line</h5>',
        bodyText: `<b>Issie Weir</b><br>oil on canvas`,
    },
    {
        paintingId: 'R1S05',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R1S04C', 'R1S05C', 'R1S06C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'R1S04C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1S04.jpg/info.json`,
        headerText: '<h5>Beach study 2</h5>',
        bodyText: `<b>Fern Acheson</b><br>Gouache on paper<br><br>open to offers`,
        instagramUrl: 'http://www.instagram.com/f_e_r_n__s',
    },
    {
        paintingId: 'R1S05C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1S05.jpg/info.json`,
        headerText: '<h5>Beach study 3</h5>',
        bodyText: `<b>Fern Acheson</b><br>Gouache on paper<br><br>open to offers`,
        instagramUrl: 'https://www.instagram.com/f_e_r_n__s',
    },
    {
        paintingId: 'R1S06C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1S06.jpg/info.json`,
        headerText: '<h5>Beach study 1</h5>',
        bodyText: `<b>Fern Acheson</b><br>Gouache on paper<br><br>open to offers`,
        instagramUrl: 'https://www.instagram.com/f_e_r_n__s',
        ContactURL: '',
    },
    {
        paintingId: 'R1W04',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=jhaf_zine&hideIssuuLogo=true&u=mixedrealitiesltd',
        headerText: '<h5>CONSTELLATIONS</h5>',
        bodyText: `JOHN HUGHES ARTS FESTIVAL <br>2021`,
        annotation_location: ANNOTATION_LOCATION.TOP_CENTER,
        annotation_location_vert_offset: 0.15,
        annotationTextAlignment: 'center',
    },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: '<h5></h5>',
    //     bodyText: ``,
    //     instagramUrl: '',
    //     ContactURL: '',
    //
    //
    // },

    /* Room 1 */

    /* Room 2 */
    {
        paintingId: 'R2E01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R2E01C', 'R2E02C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        annotation_location_horiz_offset: 0.02,
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'R2E01C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2E01.jpg/info.json`,
        headerText: '<h5>Beating Heart (Single Line)</h5>',
        bodyText: `<b>Charlotte McDonald</b><br>Acrylic Pen on Paper<br><br>In the moment of a heart beat, the blood travels through and by the next, it has moved. In this piece, a single line enters the heart with heartbeats, forms the heart and exits on heartbeats without taking the pen off of the page. A fleeting moment represented by a fleeting line.<br><br>£10 (+p&p). Multiple versions available, all originals`,
        instagramUrl: 'https://www.instagram.com/CharlotteAMcDArt/',
        ContactURL: 'https://www.etsy.com/uk/shop/CharlotteAMcDArt',
    },
    {
        paintingId: 'R2E02C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2E02.jpg/info.json`,
        headerText: '<h5>If I Only Had a Brain</h5>',
        bodyText: `<b>Charlotte McDonald</b><br>Acrylic Pen on Paper<br><br>Have you ever tried to think about something and that thought swirls in your mind? In one line, this piece winds its way around the brain and leaves as quickly as it enters, like many thoughts.<br><br>£10 (+p&p). Multiple originals available`,
        instagramUrl: 'https://www.instagram.com/CharlotteAMcDArt/',
        ContactURL: 'https://www.etsy.com/uk/shop/CharlotteAMcDArt',
    },
    {
        paintingId: 'R2E03',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2E03.jpg/info.json`,
        headerText: '<h5>Untitled 2</h5>',
        bodyText: `<b>Nik Yazikov</b><br>Gouache, pastel and pencil<br><br>`,
        instagramUrl: 'https://www.instagram.com/yazikovnik/',
        ContactURL: 'https://yazikovnik.com/',
    },
    {
        paintingId: 'R2E04',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2E04.jpg/info.json`,
        headerText: '<h5>Eve Taking A Nude</h5>',
        bodyText: `<b>Blanca Schofield Legorburo</b><br>Watercolour on watercolour paper<br><br>I started the Eve Taking A Nude art series in May 2020 because I wanted to create a warm and beautiful space of solidarity for re-writing narratives about nudity, sexualisation, self-love and religion. What if women take nudes for themselves and embrace their naked form in contemplation of their own beauty, banishing the male gaze? What if we think of Eve as a curious and confident woman rather than a reckless temptress? I have painted over 65 women since then from across the world, glowing in Edenic beauty and surrounded by Edenic flowers.<br><br>€25 for prints on my website and €35 starting price for custom paintings.`,
        instagramUrl: 'https://www.instagram.com/evetakinganude/',
        ContactURL: 'https://www.evetakinganude.com/',
    },
    {
        paintingId: 'R2E05',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2E05.jpg/info.json`,
        headerText: '<h5>*</h5>',
        bodyText: `<b>Juliet Patrick</b><br>digital painting<br><br>I like to draw my mates sometimes and to do so I use photoshop and a huion tablet.<br><br>Offers over £50`,
        instagramUrl: 'https://www.instagram.com/juliet.png/',
        ContactURL: null
    },
    {
        paintingId: 'R2N01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R2N01C', 'R2N02C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'R2N01C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2N01.jpg/info.json`,
        headerText: '<h5>Untitled (1)</h5>',
        bodyText: `<b>Fern Acheson</b><br>Watercolour and collage on paper<br><br>`,
        instagramUrl: 'https://www.instagram.com/f_e_r_n__s/',
        ContactURL: null
    },
    {
        paintingId: 'R2N02C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2N02.jpg/info.json`,
        headerText: '<h5>Untitled (2)</h5>',
        bodyText: `<b>Fern Acheson</b><br>Watercolour and collage on paper<br><br>`,
        instagramUrl: 'https://www.instagram.com/f_e_r_n__s/',
        ContactURL: null
    },
    {
        paintingId: 'R2N03',
        videoId: 'R2N03',
        standaloneVideoElementId: 'R2N03',
        videoURL: 'R2N03.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2N03.jpg/info.json`,
        headerText: '<h5>This Proposal</h5>',
        bodyText: `<b>Katie Grenville</b><br>A video proposal/cry for help made during lockdown (June 2020)<br>Digital Film. Tiny beanbags. Scale model of 3D multimedia installation. Leopard gecko.<br><br>"This Proposal" - A video proposal/cry for help made during lockdown (June 2020) was made in response to the artist's feelings towards her degree show being cancelled:<br><br>Presented with the reality of having worked for a show that may never happen, I create a proposal for a piece of work that is impossible to make.`,
        ContactURL: 'https://www.katiegrenville.com/',
        instagramUrl: 'https://www.instagram.com/katie_grenville',
        displayMesh: 'N',
        // displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R2N04',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R2N04C', 'R2N05C', 'R2N06C', 'R2N07C', 'R2N08C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'R2N04C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2N04.jpg/info.json`,
        headerText: '<h5>Untitled 1</h5>',
        bodyText: `<b>Amelie Slack</b><br>Collage: Photography, text<br><br>The work is comprised of a series of postcard-like collages, each being made up of photographic and textual elements. Such photographic elements were made using a stencil to create an image of the constellation on a pre-textured surface. The textual elements are also closely connected to the theme of constellations, the circle motif being overlayed against an extract from The Odyssey, in which the role of the stars and ideas surrounding fate are discussed. A number of letters have been removed from the text, forging visual links to star charts and maps. I found the post card a very interesting format to work with, particularly in relation to the theme of ‘constellations’, finding a tension between the use of an everyday, overlooked manmade object to translate ideas surrounding such an overwhelming and grandiose subject.`,
        instagramUrl: null,
        ContactURL: null
    },
    {
        paintingId: 'R2N05C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2N05.jpg/info.json`,
        headerText: '<h5>Untitled 2</h5>',
        bodyText: `<b>Amelie Slack</b><br>Collage: Photography, text<br><br>The work is comprised of a series of postcard-like collages, each being made up of photographic and textual elements. Such photographic elements were made using a stencil to create an image of the constellation on a pre-textured surface. The textual elements are also closely connected to the theme of constellations, the circle motif being overlayed against an extract from The Odyssey, in which the role of the stars and ideas surrounding fate are discussed. A number of letters have been removed from the text, forging visual links to star charts and maps. I found the post card a very interesting format to work with, particularly in relation to the theme of ‘constellations’, finding a tension between the use of an everyday, overlooked manmade object to translate ideas surrounding such an overwhelming and grandiose subject.`,
        instagramUrl: null,
        ContactURL: null
    },
    {
        paintingId: 'R2N06C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2N06.jpg/info.json`,
        headerText: '<h5>Untitled 3</h5>',
        bodyText: `<b>Amelie Slack</b><br>Collage: Photography, text<br><br>The work is comprised of a series of postcard-like collages, each being made up of photographic and textual elements. Such photographic elements were made using a stencil to create an image of the constellation on a pre-textured surface. The textual elements are also closely connected to the theme of constellations, the circle motif being overlayed against an extract from The Odyssey, in which the role of the stars and ideas surrounding fate are discussed. A number of letters have been removed from the text, forging visual links to star charts and maps. I found the post card a very interesting format to work with, particularly in relation to the theme of ‘constellations’, finding a tension between the use of an everyday, overlooked manmade object to translate ideas surrounding such an overwhelming and grandiose subject.`,
        instagramUrl: null,
        ContactURL: null,
    },
    {
        paintingId: 'R2N07C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2N07.jpg/info.json`,
        headerText: '<h5>Untitled 4</h5>',
        bodyText: `<b>Amelie Slack</b><br>Collage: Photography, text<br><br>The work is comprised of a series of postcard-like collages, each being made up of photographic and textual elements. Such photographic elements were made using a stencil to create an image of the constellation on a pre-textured surface. The textual elements are also closely connected to the theme of constellations, the circle motif being overlayed against an extract from The Odyssey, in which the role of the stars and ideas surrounding fate are discussed. A number of letters have been removed from the text, forging visual links to star charts and maps. I found the post card a very interesting format to work with, particularly in relation to the theme of ‘constellations’, finding a tension between the use of an everyday, overlooked manmade object to translate ideas surrounding such an overwhelming and grandiose subject.`,
        instagramUrl: null,
        ContactURL: null,
    },
    {
        paintingId: 'R2N08C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2N08.jpg/info.json`,
        headerText: '<h5>Untitled 5</h5>',
        bodyText: `<b>Amelie Slack</b><br>Collage: Photography, text<br><br>The work is comprised of a series of postcard-like collages, each being made up of photographic and textual elements. Such photographic elements were made using a stencil to create an image of the constellation on a pre-textured surface. The textual elements are also closely connected to the theme of constellations, the circle motif being overlayed against an extract from The Odyssey, in which the role of the stars and ideas surrounding fate are discussed. A number of letters have been removed from the text, forging visual links to star charts and maps. I found the post card a very interesting format to work with, particularly in relation to the theme of ‘constellations’, finding a tension between the use of an everyday, overlooked manmade object to translate ideas surrounding such an overwhelming and grandiose subject.`,
        instagramUrl: null,
        ContactURL: null,
    },
    {
        paintingId: 'R2W01',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2W01.jpg/info.json`,
        headerText: '<h5>Constellation of Friends</h5>',
        bodyText: `<b>Ella Curry</b><br>Digital artwork made using Procreate<br><br>I created these pieces over a few weeks as free commissions for my friends and family in order to get to grips with my new digital art software, and to create personalised gifts for the people that I would be moving away from with university. Each one features somebody close to me, their star-sign, and the corresponding constellation. With the star-signs, I tried to incorporate them subtly into the pictures, so it can be quite enjoyable to try to spot them!`,
        instagramUrl: 'https://www.instagram.com/ellamentarycrafts/',
        ContactURL: null,
    },
    {
        paintingId: 'R2W02',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2W02.jpg/info.json`,
        headerText: '<h5>House and Home</h5>',
        bodyText: `<b>Sophie Neville</b><br>Embroidered linen and calico<br><br>Houses have been stitched (mainly by women) into embroidery samplers since the 17th century. The home would often have been the only place that women asserted any power, and many would have had very little life outside their home. It’s no surprise that houses became a popular choice for embroidery, and have remained a staple of samplers since. In lockdown, many of us have also experienced having little life outside our homes. This has given us an insight into how people in the past and present live when social pressures or disabilities force them to stay inside.<br><br>This work is a fabric patchwork featuring 64 hand embroidered houses. The designs are appropriated from samplers which age from the 1600s to the present day.<br><br>£1,000`,
        instagramUrl: 'http://instagram.com/sophienevilleart',
        ContactURL: 'http://sophienevilleart.wordpress.com/',
    },
    {
        paintingId: 'R2S03',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R2S01C', 'R2S02C', 'R2S03C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'R2S01C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S01.jpg/info.json`,
        headerText: '<h5>Otherwhere (Orvieto)</h5>',
        bodyText: `<b>Alex Haydn-Williams</b><br>Giclée print of 35mm photograph<br><br>£15 for one, £30 for all three`,
        instagramUrl: 'https://www.instagram.com/a.green.sun/',
        ContactURL: null,
    },
    {
        paintingId: 'R2S02C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S02.jpg/info.json`,
        headerText: '<h5>Otherwhere (Rome)</h5>',
        bodyText: `<b>Alex Haydn-Williams</b><br>Giclée print of 35mm photograph<br><br>These pieces are the first experiments in a project called Otherwhere, (a bit ostentatiously) after a word that W. H. Auden invented to describe the Italian South. During the first lockdown, as summer failed to happen outside, I got a bit obsessed with reading English writers' accounts of Italy. When they went south, had these writers actually seen the nation that calls itself Italia - or was their experience an English projection we call Italy? And when I'd gone interrailing the previous summer through cities I'd visited before as a language student, which had I seen?<br>To try and answer those questions, I used Photoshop to put tiny snippets of texts over pictures I'd taken with my little Nineties tourist camera. By using the style of an old-fashioned colour supplement (heavily inspired by Victor Burgin), I wanted to conjure up visual tensions between text and image, the canonical and the personal, Italy and Italia, lived experience and learned legends, photography and memory.<br>The text here was first written by Shakespeare in Othello, then picked up by the poet Ishion Hutchinson in a poem about Venice.<br><br>£15 for one, £30 for all three`,
        instagramUrl: 'https://www.instagram.com/a.green.sun/',
        ContactURL: null,
    },
    {
        paintingId: 'R2S03C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S03.jpg/info.json`,
        headerText: '<h5>Otherwhere (Vatican)</h5>',
        bodyText: `<b>Alex Haydn-Williams</b><br>Giclée print of 35mm photograph<br><br>The text here is from E. M. Forster's A Room With A View.<br><br>£15 for one, £30 for all three`,
        instagramUrl: 'https://www.instagram.com/a.green.sun/',
        ContactURL: null,
    },
    {
        paintingId: 'R2S04',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S04.jpg/info.json`,
        headerText: '<h5>Elly, Landscape in Blue</h5>',
        bodyText: `<b>Tabitha Blackburn</b><br>Oil and acrylic on canvas<br><br>In light of the theme ‘Constellations’, my painting draws upon ideas of other-worldliness and connection. The pattern takes the place of the landscape where earth, scape and sky are one, illustrating the boundlessness of nature. The figure grounds it, and brings to light the relationship between the earthly and the other-worldly; the ordinary and the extraordinary.`,
        instagramUrl: 'https://www.instagram.com/tab__itha/',
        ContactURL: null,
    },
    {
        paintingId: 'R2S05',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S05.jpg/info.json`,
        headerText: '<h5>Laguna Tebinquinche</h5>',
        bodyText: `<b>Toby Ashworth</b><br>4-colour reduction linocut<br><br>I made this 4-colour reduction linocut based on a photograph I took, at sunset, in northern Chile in July 2018. Laguna Tebinquinche (or Tebinquiche) is a salt lake in the Atacama Desert, an extremely arid place with one of the lowest rainfall levels in the world. Usually the skies are incredibly clear - at night you can see the Milky Way - but as the sun set on that day, a weather front was passing overhead and caused an unusual hand-shaped cloud formation that became increasingly vivid as the sky darkened. In this linocut I attempt to capture the impression I had of the enormous scale of the sunset's forms, and also the lake's thousands of tiny pools of salty water that were reflecting it back within their own form.<br>The process for a reduction linocut involves cutting into a block of lino, printing with one colour, then cutting additional material from the same block again and printing with a different colour, so that several layers of colour are printed to compose an image.`,
        instagramUrl: null,
        ContactURL: null,
    },
    {
        paintingId: 'R2S06',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S06.jpg/info.json`,
        headerText: '<h5>Fort San Pedro</h5>',
        bodyText: `<b>Anja Diel</b><br>Acrylic on canvas<br><br>This is a painting of a photograph I took of a place called Fort San Pedro, which is in my home city in the Philippines. I painted it a few days after I got back from the Philippines, so the atmosphere of the place was still fresh in my mind. The fort used to protect the island, but now it's fallen down, and has become a place people go to in the evenings to catch sea breeze.`,
        instagramUrl: null,
        ContactURL: null,
    },
    {
        paintingId: 'R2S07',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['R2S07C','R2S08C', 'R2S09C'],
        // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
        // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
        // annotation_location_z_offset: 0.5,
        // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    },
    {
        paintingId: 'R2S07C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S07.jpg/info.json`,
        headerText: '<h5>March 31, from the series Small Victories</h5>',
        bodyText: `<b>Ella Nowicki</b><br>Marker on paper<br><br>I started these small marker drawings during the first two months of the pandemic. They document moments of hope that seem impossible now (phone banking for Bernie Sanders) and moments that seemed impossible then but have now morphed into hope (the morning before visiting my grandpa for the last time). The drawings' limited scope and fragmented forms are meant to simultaneously insulate them from and connect them to the events that surround them. I tried to use confinement to my advantage—to confine my attention to the objects right in front of me when the wider world was overwhelming.`,
        instagramUrl: null,
        ContactURL: null,
    },
    {
        paintingId: 'R2S08C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S08.jpg/info.json`,
        headerText: '<h5>April 1, from the series Small Victories</h5>',
        bodyText: `<b>Ella Nowicki</b><br>Marker on paper<br><br>I started these small marker drawings during the first two months of the pandemic. They document moments of hope that seem impossible now (phone banking for Bernie Sanders) and moments that seemed impossible then but have now morphed into hope (the morning before visiting my grandpa for the last time). The drawings' limited scope and fragmented forms are meant to simultaneously insulate them from and connect them to the events that surround them. I tried to use confinement to my advantage—to confine my attention to the objects right in front of me when the wider world was overwhelming.`,
        instagramUrl: null,
        ContactURL: null,
    },
    {
        paintingId: 'R2S09C',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S09.jpg/info.json`,
        headerText: '<h5>April 4 from the series Small Victories</h5>',
        bodyText: `<b>Ella Nowicki</b><br>Marker on paper<br><br>I started these small marker drawings during the first two months of the pandemic. They document moments of hope that seem impossible now (phone banking for Bernie Sanders) and moments that seemed impossible then but have now morphed into hope (the morning before visiting my grandpa for the last time). The drawings' limited scope and fragmented forms are meant to simultaneously insulate them from and connect them to the events that surround them. I tried to use confinement to my advantage—to confine my attention to the objects right in front of me when the wider world was overwhelming.`,
        instagramUrl: null,
        ContactURL: null,
    },
    {
        paintingId: 'R2S10',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R2S10.jpg/info.json`,
        headerText: '<h5>Milky Way Chasing, Gengenbach</h5>',
        bodyText: `<b>Aoife Clark</b><br>Photography<br><br>Being somewhat of a night owl, I can spend hours just looking up at the night sky admiring the stars. I love that the camera can capture more than what the eye can see, and how the Milky Way appears different in colour in every location.`,
        instagramUrl: null,
        ContactURL: null,
    },

    /* Room 2 */
];

export {AnnotationsDB};
